import styled from 'styled-components'
import { media, radiuses, colors } from 'styles'

const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  z-index: 1001;
  background-color: rgba(0, 0, 0, 0.8);
  color: ${colors.textMain};

  overflow: auto; /* column, space-between and before|after hack to get scrollable centered content */
  flex-direction: column;
  justify-content: space-between; /* space-around cuts of part of content when height > 100% */
  &::before,
  &::after {
    content: '';
  }

  .close-btn {
    position: absolute;
    right: 0.5rem;
    top: -2.5rem;
    width: 1.5rem;
    height: 1.5rem;
    cursor: pointer;
  }

  .content {
    position: relative;
    padding: ${p => (p.transparentBackground ? '0' : '1.5rem')};
    border-radius: ${radiuses.medium};
    background-color: ${p => (p.transparentBackground ? 'transparent' : p.theme.colors.mainBackground)};
    max-width: 80%;
    max-height: 80vh;
  }

  ${media.mobile`
    .content {
      width: 80%;
    }
  `}
`

export default StyledModal
